// https://emailregex.com/
const emailPattern =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const passwordPattern = /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?!.*[/&.<>`|~\s]).{8,30}$/;

export const checkRequiredFields = (requiredKeys, obj, reqLength = 1) => {
  if (!obj) return false;
  return requiredKeys.every((key) => Object.keys(obj).includes(key) && obj[key].length >= reqLength);
};

export const validatePasswordRules = ({ password, login = '' }) => {
  const rules = passwordPattern.test(password);
  const isLoginInPassword = !password.match(new RegExp(login, 'i'));
  return rules && isLoginInPassword;
};

export const passwordValidation = ({ password = '', reenter = '' }, login = '') =>
  validatePasswordRules({ password, login }) && password === reenter;
export const emailValidation = ({ login = '' }) => emailPattern.test(login);

//test
// Object.keys(obj).includes(key) ? obj[key].length >= reqLength : false
